import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Card, CardContent, Stack, TextField, Typography, } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { FormActions } from "../utils/FormActions";
export const DivisionForm = ({ onSubmit, seasonId, existingDivisions = [], division, }) => {
    const { control, handleSubmit, formState: { errors }, } = useForm({
        defaultValues: {
            name: division?.name || "",
            tier: division?.tier || 1,
            description: division?.description || "",
            season: seasonId,
        },
    });
    // Validation helpers
    const validateUniqueName = (name) => {
        if (!name)
            return true; // Let required validation handle empty names
        const trimmedName = name.trim();
        if (!trimmedName)
            return true;
        const existingName = existingDivisions.find((div) => div.name.toLowerCase() === trimmedName.toLowerCase() &&
            div.id !== division?.id // Allow current division name when editing
        );
        return !existingName || "A division with this name already exists";
    };
    const handleFormSubmit = (data) => {
        onSubmit({
            ...data,
            season: seasonId,
            id: division?.id, // Include ID for updates
        });
    };
    return (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "h6", gutterBottom: true, children: division ? "Update Division" : "Create Division" }), _jsx(Box, { component: "form", role: "form", onSubmit: handleSubmit(handleFormSubmit), sx: { mt: 1 }, children: _jsxs(Stack, { spacing: 2, children: [_jsx(Controller, { name: "name", control: control, rules: {
                                    required: "Division name is required",
                                    validate: validateUniqueName,
                                }, render: ({ field }) => (_jsx(TextField, { ...field, label: "Division Name", placeholder: "e.g., Premier League, Championship", required: true, fullWidth: true, error: !!errors.name, helperText: errors.name?.message })) }), _jsx(Controller, { name: "tier", control: control, rules: {
                                    required: "Tier is required",
                                    min: { value: 1, message: "Tier must be at least 1" },
                                    max: { value: 10, message: "Tier cannot exceed 10" },
                                }, render: ({ field }) => (_jsx(TextField, { ...field, label: "Tier", type: "number", required: true, fullWidth: true, inputProps: { min: 1, max: 10 }, helperText: errors.tier?.message ||
                                        "1 = highest tier, 2 = second tier, etc. Multiple divisions can share the same tier.", error: !!errors.tier, onChange: (e) => field.onChange(parseInt(e.target.value)) })) }), _jsx(Controller, { name: "description", control: control, render: ({ field }) => (_jsx(TextField, { ...field, label: "Description (Optional)", multiline: true, rows: 3, fullWidth: true, placeholder: "Optional description for this division" })) }), _jsx(FormActions, { submitLabel: division ? "Update Division" : "Create Division" })] }) })] }) }));
};
